import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import theme from '../../styles/theme';
import BrandLogo from '../common/BrandLogo';

const PublicFooter = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const columns = [
    {
      heading: t('public.footer.product', 'Product'),
      links: [
        { label: t('public.nav.features', 'Features'), to: '/features' },
        { label: t('public.footer.pricing', 'Pricing'), to: '/pricing' },
      ],
    },
    {
      heading: t('public.footer.company', 'Company'),
      links: [
        { label: t('public.nav.contact', 'Contact'), to: '/contact' },
        { label: t('public.footer.privacy', 'Privacy Policy'), to: '/privacy' },
        { label: t('public.footer.terms', 'Terms of Service'), to: '/terms' },
      ],
    },
  ];

  const s = {
    footer: {
      backgroundColor: theme.colors.neutral[900],
      color: theme.colors.neutral[300],
      paddingTop: theme.spacing['3xl'],
      paddingBottom: theme.spacing.xl,
    },
    inner: {
      maxWidth: '1120px',
      margin: '0 auto',
      padding: `0 ${theme.spacing.xl}`,
    },
    topRow: {
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr',
      gap: theme.spacing['2xl'],
      paddingBottom: theme.spacing['2xl'],
      borderBottom: `1px solid ${theme.colors.neutral[700]}`,
    },
    logoBlock: {},
    logoText: {
      marginBottom: theme.spacing.md,
      display: 'inline-block',
    },
    tagline: {
      fontSize: theme.typography.fontSize.sm,
      lineHeight: theme.typography.lineHeight.relaxed,
      color: theme.colors.neutral[400],
      maxWidth: '260px',
    },
    colHeading: {
      fontSize: theme.typography.fontSize.sm,
      fontWeight: theme.typography.fontWeight.semibold,
      color: '#fff',
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      marginBottom: theme.spacing.md,
      display: 'block',
    },
    colLink: {
      display: 'block',
      fontSize: theme.typography.fontSize.sm,
      color: theme.colors.neutral[400],
      textDecoration: 'none',
      marginBottom: theme.spacing.sm,
      transition: `color ${theme.transitions.fast}`,
    },
    bottomRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: theme.spacing.xl,
      flexWrap: 'wrap',
      gap: theme.spacing.md,
    },
    copy: {
      fontSize: theme.typography.fontSize.sm,
      color: theme.colors.neutral[400],
    },
    bottomLinks: {
      display: 'flex',
      gap: theme.spacing.lg,
    },
    bottomLink: {
      fontSize: theme.typography.fontSize.sm,
      color: theme.colors.neutral[400],
      textDecoration: 'none',
    },
  };

  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <div style={s.topRow} className="public-footer-grid">
          {/* Brand */}
          <div style={s.logoBlock}>
            <span style={s.logoText}>
              <BrandLogo
                label="Waggy"
                size={34}
                textSize={theme.typography.fontSize['2xl']}
                markColor={theme.colors.primary.main}
                symbolColor="#FFFFFF"
                accentColor={theme.colors.accent.main}
                textColor="#FFFFFF"
              />
            </span>
            <p style={s.tagline}>
              {t('public.footer.tagline', 'The ERP built for pet product stores — inventory, sales, pets, daycare and grooming in one place.')}
            </p>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <div key={col.heading}>
              <span style={s.colHeading}>{col.heading}</span>
              {col.links.map(({ label, to }) => (
                <Link
                  key={to}
                  to={to}
                  style={s.colLink}
                  onMouseOver={(e) => (e.target.style.color = '#fff')}
                  onMouseOut={(e) => (e.target.style.color = theme.colors.neutral[400])}
                >
                  {label}
                </Link>
              ))}
            </div>
          ))}


        </div>

        <div style={s.bottomRow}>
          <span style={s.copy}>
            © {year} Waggy ERP. {t('public.footer.rights', 'All rights reserved.')}
          </span>
          <div style={s.bottomLinks}>
            <Link to="/privacy" style={s.bottomLink}
              onMouseOver={(e) => (e.target.style.color = '#fff')}
              onMouseOut={(e) => (e.target.style.color = theme.colors.neutral[400])}>
              {t('public.footer.privacy', 'Privacy')}
            </Link>
            <Link to="/terms" style={s.bottomLink}
              onMouseOver={(e) => (e.target.style.color = '#fff')}
              onMouseOut={(e) => (e.target.style.color = theme.colors.neutral[400])}>
              {t('public.footer.terms', 'Terms')}
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .public-footer-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default PublicFooter;
